const printPartialPage = () => {
    const openWindow: any = window.open("", "Print", "attributes");
    openWindow.document.write(`
        <html>
            <body>
            <style>
                body{
                    font-family: 'Roboto', sans-serif !important;
                }
                #wirePaymentContainer{
                    width:90% !important;
                }
                .wirepayment-bank-account-details{
                    border: none !important;
                }
                .print-wire-payment-info{
                    width: 50% !important;
                }
                .print-wirepayment-bank-account-details{
                    width:45% !important;
                    float: inline-end !important;
                    margin-top: -424px !important;
                    border: 1px solid #C3D4EA;
                    padding-left: 40px !important;
                }
                .wire-heading{
                    color: #2060AD !important;
                    font-size: 1.125rem !important;
                    font-weight: bold !important;
                    line-height: 1.375rem !important;
                    font-family: 'Roboto', sans-serif !important;
                }
                .print-account-details{
                    display: flex !important;
                }
                .account-receivable-phone{
                    display: inline-flex !important;
                    width:30% !important;
                }
                .account-receivable-email{
                    display: inline-flex !important;
                    width:32% !important;
                }
                .account-receivable-other{
                    display: inline-flex !important;
                    width:30% !important;
                }
                .info-message{
                    width: 100% !important;
                    border: 1px solid #FFDEB2 !important;
                    border-radius: 2px !important;
                    background-color: #FFEFD9 !important;
                    padding: 10px !important;
                    display: flex !important;
                    margin-top: 10px !important;
                    margin-bottom:10px !important;
                    color: #002554 !important;
                }
                .print-hide-items{
                    visibility: hidden !important;
                }
                .wire-tax-label{
                    margin-right: 20px !important;
                }
            </style>
            ${applyCssClassesAsInlineStyles("wirePaymentContainer")}
            </body>
        </html>
    `);

    const wirePaymentContainerStyle = openWindow.document.querySelector("#wirePaymentContainer")?.style;
    if (wirePaymentContainerStyle) {
        wirePaymentContainerStyle.margin = "20px";
        wirePaymentContainerStyle.padding = "20px";
    }

    openWindow.document.close();
    openWindow.onload = () => {
        openWindow.print();
    };
    setTimeout(() => {
        openWindow.close();
    }, 1500);
};

function applyCssClassesAsInlineStyles(elementId: any) {
    try {
        const element = document.getElementById(elementId);
        if (!element) {
            return null;
        }

        const clone: any = element.cloneNode(true);

        // eslint-disable-next-line no-inner-declarations
        function applyStyles(el: any) {
            const styleSheets = document.styleSheets;
            const style = window.getComputedStyle(el);

            Array.from(styleSheets).forEach(sheet => {
                Array.from(sheet?.cssRules || []).forEach((rule: any) => {
                    if (rule.selectorText && el.matches(rule.selectorText)) {
                        const cssText = rule.style.cssText
                            .split(";")
                            .map((s: any) => s.trim())
                            .filter((s: any) => s);
                        cssText.forEach((styleRule: any) => {
                            const [key, value] = styleRule.split(":").map((s: any) => s.trim());
                            el.style[key] = value;
                        });
                    }
                });
            });
            el.style.display = style.display;
        }

        applyStyles(clone);
        Array.from(clone.getElementsByTagName("*")).forEach(applyStyles);
        return clone?.outerHTML;
    }
    catch (e) {
        console.log("applyCssClassesAsInlineStyles", e);
    }
}

export default printPartialPage;
